type CI_ENVIRONMENT_NAMES =
    | 'eon-hems-dev'
    | 'eon-hems-feature-1'
    | 'eon-hems-feature-2'
    | 'eon-hems-feature-3'
    | 'eon-hems-feature-4'
    | 'eon-hems-feature-5'
    | 'eon-hems-qa'
    | 'eon-hems-qa-2'
    | 'eon-hems-prod'
    | 'eon-hems-prod-2';

export const CI_ENVIRONMENT_NAME =
    (process.env.CI_ENVIRONMENT_NAME as CI_ENVIRONMENT_NAMES) || 'eon-hems-dev';

type CI_ENVIRONMENT_TIERS = 'development' | 'staging' | 'production';

export const CI_ENVIRONMENT_TIER: CI_ENVIRONMENT_TIERS = (() => {
    switch (CI_ENVIRONMENT_NAME) {
        case 'eon-hems-dev':
        case 'eon-hems-feature-1':
        case 'eon-hems-feature-2':
        case 'eon-hems-feature-3':
        case 'eon-hems-feature-4':
        case 'eon-hems-feature-5':
            return 'development';
        case 'eon-hems-qa':
        case 'eon-hems-qa-2':
            return 'staging';
        case 'eon-hems-prod':
        case 'eon-hems-prod-2':
            return 'production';
        default:
            return 'development';
    }
})();

export const API_URL_DEFAULT: string = (() => {
    switch (CI_ENVIRONMENT_NAME) {
        case 'eon-hems-dev':
            return 'https://dashboard.api.dev.eonhome.eu';
        case 'eon-hems-feature-1':
            return 'https://dashboard.api.feature-one.dev.eonhome.eu';
        case 'eon-hems-feature-2':
            return 'https://dashboard.api.feature-two.dev.eonhome.eu';
        case 'eon-hems-feature-3':
            return 'https://dashboard.api.feature-three.dev.eonhome.eu';
        case 'eon-hems-feature-4':
            return 'https://dashboard.api.feature-four.dev.eonhome.eu';
        case 'eon-hems-feature-5':
            return 'https://dashboard.api.feature-five.dev.eonhome.eu';
        case 'eon-hems-qa':
            return 'https://dashboard.api.qa.eonhome.eu';
        case 'eon-hems-qa-2':
            return 'https://dashboard.api.qa.eonhome.eu';
        case 'eon-hems-prod':
            return 'https://data.home.eon.com';
        case 'eon-hems-prod-2':
            return 'https://dashboard.api.app2.prod.eonhome.eu';
        default:
            return 'https://dashboard.api.dev.eonhome.eu';
    }
})();

export const APP_ICON = `${window.location.origin}/brand/assets/app-icons/icon-128x128.png`;

export const APP_URL = window.location.origin;

export const CIAM_LOGOUT: string = (() => {
    switch (CI_ENVIRONMENT_TIER) {
        case 'development':
            return 'https://account-qa.eon.com/s/logout';
        case 'staging':
            return 'https://account-pp.eon.com/s/logout';
        case 'production':
            return 'https://account.eon.com/s/logout';
        default:
            return 'https://account-qa.eon.com/s/logout';
    }
})();

export const CMS_BASE_PATH: string = (() => {
    switch (CI_ENVIRONMENT_NAME) {
        case 'eon-hems-dev':
            return 'https://hems-cms.dev.eonhome.eu';
        case 'eon-hems-feature-1':
            return 'https://hems-cms.feature-one.eonhome.eu';
        case 'eon-hems-feature-2':
            return 'https://hems-cms.feature-two.eonhome.eu';
        case 'eon-hems-feature-3':
            return '';
        case 'eon-hems-feature-4':
            return '';
        case 'eon-hems-feature-5':
            return '';
        case 'eon-hems-qa':
            return 'https://hems-cms.qa.eonhome.eu';
        case 'eon-hems-qa-2':
            return 'https://hems-cms.qa.eonhome.eu';
        case 'eon-hems-prod':
            return 'https://hems-cms.prod.eonhome.eu';
        case 'eon-hems-prod-2':
            return 'https://hems-cms.prod.eonhome.eu';
        default:
            return 'https://hems-cms.dev.eonhome.eu';
    }
})();

export const GOOGLE_TAG_MANAGER_ID = 'GTM-MG5LFTG';

export const IS_NOT_DEV = CI_ENVIRONMENT_TIER !== 'development';

export const IS_PROD = CI_ENVIRONMENT_TIER === 'production';

export const LOGIN_URL = `${window.location.origin}/login`;

export const NEW_RELIC_APP_ID =
    CI_ENVIRONMENT_TIER === 'production' ? '538684573' : '';

export const WEBSOCKET_URL_DEFAULT: string = (() => {
    switch (CI_ENVIRONMENT_TIER) {
        case 'development':
            return 'wss://stream.dev.eonhome.eu';
        case 'staging':
            return 'wss://stream.qa.eonhome.eu';
        case 'production':
            return 'wss://stream.home.eon.com';
        default:
            return 'wss://stream.dev.eonhome.eu';
    }
})();
